/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InTransactionDto } from './inTransactionDto';


export interface ReportDto { 
    id?: number;
    uuid?: string;
    created?: string;
    type?: ReportDto.TypeEnum;
    status?: ReportDto.StatusEnum;
    description?: string;
    conclusion?: string;
    transaction?: InTransactionDto;
}
export namespace ReportDto {
    export type TypeEnum = 'WRONG_POINTS' | 'WRONG_COMPANY' | 'WRONG_INVOICE_NO' | 'WRONG_DATE_TIME' | 'WRONG_DATA' | 'UNKNOWN_ERROR';
    export const TypeEnum = {
        WrongPoints: 'WRONG_POINTS' as TypeEnum,
        WrongCompany: 'WRONG_COMPANY' as TypeEnum,
        WrongInvoiceNo: 'WRONG_INVOICE_NO' as TypeEnum,
        WrongDateTime: 'WRONG_DATE_TIME' as TypeEnum,
        WrongData: 'WRONG_DATA' as TypeEnum,
        UnknownError: 'UNKNOWN_ERROR' as TypeEnum
    };
    export type StatusEnum = 'INITIALIZED' | 'PROCESSING' | 'ON_HOLD' | 'CLOSED';
    export const StatusEnum = {
        Initialized: 'INITIALIZED' as StatusEnum,
        Processing: 'PROCESSING' as StatusEnum,
        OnHold: 'ON_HOLD' as StatusEnum,
        Closed: 'CLOSED' as StatusEnum
    };
}


